var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.046 3.353h5.908c.408 0 .74.33.74.738v3.693h2.084c.48 0 .87.39.87.87v7.124c0 .48-.39.87-.87.87H4.222a.87.87 0 0 1-.87-.87V8.654c0-.48.39-.87.87-.87h2.085V4.091c0-.408.33-.738.739-.738m.738 1.477v2.954h4.432V4.83z"
})));
export default SvgBag;